import * as React from 'react';
import {StorageSuccessModal} from "./StorageSuccessModal";
import {
    EditCarMtaSuccessModalWordingGenerator
} from "../../pages/dashboard/annual/motor/yourCarsPage/modal/EditCarMtaSuccessModalWordingGenerator";

export class RenewNextYearConfirmationModal extends React.Component<{}> {

    public render(): React.ReactNode {
        return (
            <StorageSuccessModal
                title="All done!"
                explanationWording={
                <>
                    <p>We'll let you know your new price and cover details in plenty of time before your renewal date and you can opt out any time you like, free of charge.</p>
                    <p className="font-weight-bold">
                        You have set up your car policy to renew next year.<br/>
                        You do not need to inform us of the change by email or do anything else.
                    </p>
                </>}
                anythingElseTitle={EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalTitle()}
                explanationAnythingElseWording={EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalBody()}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modals/RenewNextYearConfirmationModal.tsx